"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @file Created on Thu Feb 14 2019
 */

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * WindowItemSimulationConverter.
 *
 * @author BPo
 */


var WindowItemSimulationConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(WindowItemSimulationConverter, _DataObjectConverter_);

  function WindowItemSimulationConverter() {
    _classCallCheck(this, WindowItemSimulationConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(WindowItemSimulationConverter).apply(this, arguments));
  }

  return WindowItemSimulationConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.WindowItemSimulationConverter = WindowItemSimulationConverter;